// extracted by mini-css-extract-plugin
module.exports = {"button":"back-to-top_button__sLmJP"};